import React from "react";
import FooterContact from "../../component/FooterContact";
import { PATH } from "../../globals/app-constants";
import PortfolioDetail from "../../component/PortfolioDetail";
import SliderCards from "../../component/SliderCards";
import { Link } from "react-router-dom";

const FreshersAll = () => {
    const Portfoliodetail = [{
        title: 'Case highlights',
        point1: "React-Powered Interface: Utilizes React to craft a dynamic and user-friendly interface, enhancing the website's interactivity.",
        point2: "Efficient Data Fetching: Harnesses GraphQL to efficiently retrieve data from multiple sources, enabling swift access to diverse information.",
        point3: "Cloud-Based Scalability: Utilizes AWS and GCP, ensuring scalability and reliability for a growing user base, ensuring seamless service."
    },
    {
        title: 'Business challenge',
        challengeDescription: "Ensuring an informative, user-friendly, and accessible website for a diverse user base.",
    },
    {
        title: 'Overcoming Challenges',
        point1: "Technology Integration: Strategic integration of React and GraphQL for an enriched user experience and efficient data handling.",
        point2: "Cloud-based Scalability: Leveraging AWS and GCP to guarantee reliable performance and scalability for an expanding user community."
    },
    {
        title: 'Delivered solution',
        deliveredParagraph1: "FreshersAll strategically integrates React, GraphQL, AWS, and GCP to create an informative, user-centric, and accessible job portal. Proglint's role in implementing these innovative technologies has significantly enhanced the platform's efficiency, accessibility, and scalability, catering to a wide array of job seekers.",
    }
    ]

    return (
        <div>
            <PortfolioDetail
                imgSrc={PATH.img.FreshersAllBanner}
                bannerSubtitle={'Success Story'}
                bannerTitle={'Empowering Job Seekers with Innovative Technologies'}
                domainText={'Job Portal, Government Jobs, Informational Platform'}
                durationText={'3 months, 8 man-months'}
                technologyText={'React Framework, GraphQL, AWS, GCP, CMS'}
                overviewText={'FreshersAll, a leading job and current affairs portal, leverages cutting-edge technologies in website development to offer an enriched user experience. With its foundation on React, a dynamic JavaScript library for crafting user interfaces, FreshersAll ensures an interactive and engaging platform for job seekers. Moreover, the integration of GraphQL enhances data retrieval efficiency, allowing seamless access to various sources like internal databases and third-party APIs.'}
                Portfoliodetails={Portfoliodetail}

            />
            <div className="related_project bg-background">
                <div className="container mx-auto py-5">
                    <div className="flex justify-between items-end">
                        <h1 className="text-hColor font-bold text-2xl capitalize mb-3">Related projects</h1>
                        {/* <div className="flex gap-3">
                            <ArrowLongLeftIcon className="w-12 text-gray-400" />
                            <ArrowLongRightIcon className="w-12" />
                        </div> */}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-y-8 py-8 ">
                        <SliderCards ImgPath={PATH.img.LeelaKitchenThumbnail} RetailHeading={'Food & Catering technology'} SubHead={'Leela-kitchen'} ParaContent={`Experience a culinary transformation with Proglint's innovative solution tailored for Leela Kitchen. Our efficient ordering system redefines the customer journey, offering seamless dish selection and smart inventory management. Enhance your service with our cost-effective, tech-driven food ordering approach.`}
                            profileContent={
                                <>
                                    <Link className="my-5 underline text-xs font-bold text-secondary text-start" to={('/case-studies/leela-kitchen')}>Read more</Link>
                                </>
                            } />
                        <SliderCards ImgPath={PATH.img.PaulFashionThumbnail} RetailHeading={'Fashion'} SubHead={`Paul's Fashion`} ParaContent={`Paul's Fashion, a longstanding tailor shop in Thailand, embraced innovation by launching an e-commerce app. Proglint facilitated this transition, delivering a seamless platform where customers effortlessly customize garments. The app's user-friendly interface enhanced the shopping experience, enabling personalized clothing selections with ease.`}
                            profileContent={
                                <>
                                    <Link className="my-5 underline text-xs font-bold text-secondary text-start" to={('/case-studies/pauls-fashion')}>Read more</Link>
                                </>
                            } />
                         <SliderCards ImgPath={PATH.img.shopAppThumbnail} RetailHeading={'E-commerce'} SubHead={'Shop App'} ParaContent={`The Proglint-assisted Shop Management Solution introduced an innovative system integrating inventory control with customer and store management applications. Collaborating as a technology facilitator, Proglint supported the client in implementing intricate inventory algorithms and advanced technological functionalities. This collaborative effort aimed to enhance stock control precision and streamline the customer experience. The solution's success lay in its intricate promotional strategies and the implementation of Planogram via cutting-edge technology.`}
                            profileContent={
                                <>
                                    <Link className="my-5 underline text-xs font-bold text-secondary text-start" to={('/case-studies/shopapp-app')}>Read more</Link>
                                </>
                            } />

                    </div>
                </div>
            </div>
            <FooterContact />
        </div>
    );
};
export default FreshersAll;